import React from "react";
import { observer } from "mobx-react-lite";
import { useGetTabTitle } from "src/system/useGetTabTitle.tsx";
import type { StorageKey } from "@exonn/storage";

export const EditTabTitleV2 = observer(
  ({
    id,
    storageKey,
    TitleComponent,
  }: {
    id: string;
    storageKey: StorageKey;
    TitleComponent?: React.ComponentType<{ title: string }>;
  }) => {
    const title = useGetTabTitle({ storageKey, id });

    if (!title) {
      return null;
    }

    if (TitleComponent) {
      return <TitleComponent title={title} />;
    }

    return <>{title}</>;
  },
);
